import React, {Component} from 'react';
import {v4 as uuidv4} from "uuid";
import {MechanicsView} from "./MechanicsView";
import {Forces} from "./Forces";
import {getBox} from "./Box";
import {CheckboxList} from "../CheckboxList";

export class Molecules extends Component {
    static displayName = Molecules.name;

    constructor(props) {
        super(props);
        const numberOfObjects = 20;
        const size = {width: 370, height: 700};
        const wallWidth = 10;
        const buffer = 2;
        const box = getBox(wallWidth + buffer, size.height - wallWidth - buffer, wallWidth + buffer, size.width - wallWidth - buffer, wallWidth);
        const forces = this.getForces(box.box);
        const maxRadius = 30;
        const objectInfo = {
            minRadius: 15,
            maxRadius: maxRadius,
            upperLeft: {x: box.box.left + maxRadius + buffer, y: box.box.top + maxRadius + buffer},
            lowerRight: {x: box.box.right - maxRadius - buffer, y: box.box.bottom - maxRadius - buffer}
        };
        this.state = {
            objects: this.randomizeObjects(numberOfObjects, objectInfo),
            objectInfo: objectInfo,
            box: box,
            forces: forces,
            size: size,
            numberOfObjects: numberOfObjects,
        };
        this.handleForceChange = this.handleForceChange.bind(this);
        this.handleAddClick = this.handleAddClick.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.removeObject = this.removeObject.bind(this);
        this.handleObjectClick = this.handleObjectClick.bind(this);
    }

    getForces = (box) => {
        const gravityConstant = 1;
        const vanDerWaalsConstant = 1000;
        const wallReflection = 0.8;
        const dampingConstant1 = 10;
        const dampingConstant2 = 0.1;

        const force = Forces();
        return [
            force.gravity(gravityConstant),
            force.vanDerWaals(vanDerWaalsConstant),
            force.damping(dampingConstant1, dampingConstant2),
            force.reflectionBottomWall(box.bottom, wallReflection),
            force.reflectionLeftWall(box.left, wallReflection),
            force.reflectionRightWall(box.right, wallReflection),
            force.reflectionTopWall(box.top, wallReflection)
        ].map(f => {
            f.enabled = true;
            return f;
        });
    }

    randomizeObjects(numberOfObjects, objectInfo) {
        const result = [];
        for (let i = 0; i < numberOfObjects; i++) {
            result.push(this.createObject(objectInfo));
        }

        return result;
    }

    createObject(objectInfo) {
        const radius = objectInfo.minRadius + Math.floor(Math.random() * (objectInfo.maxRadius - objectInfo.minRadius + 1));
        const mass = radius * radius;
        const x = objectInfo.upperLeft.x + Math.floor(Math.random() * (objectInfo.lowerRight.x - objectInfo.upperLeft.x + 1));
        const y = objectInfo.upperLeft.y + Math.floor(Math.random() * (objectInfo.lowerRight.y - objectInfo.upperLeft.y + 1));
        const id = uuidv4();
        return {
            id: id,
            r: {x, y, z: 0},
            v: {x: 0, y: 0, z: 0},
            radius: radius,
            m: mass,
            color: this.getRandomColor()
        };
    }

    getRandomColor() {
        // Gets a random color that's not too close to black or white: 
        const letters = '789ABCD';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * letters.length)];
        }
        return color;
    }

    addObject(position) {
        const maxObjects = 50;
        if (this.state.numberOfObjects >= maxObjects) return;
        const newObjects = this.state.objects;
        const newObject = this.createObject(this.state.objectInfo);
        if (position?.x > 0) newObject.r.x = position.x;
        if (position?.y > 0) newObject.r.y = position.y;
        newObjects.push(newObject);
        this.setState({objects: newObjects, numberOfObjects: this.state.numberOfObjects + 1});
    }

    removeObject(id) {
        if (this.state.numberOfObjects <= 0) return;
        const newObjects = this.state.objects;
        if (id) {
            const itemToRemove = newObjects.filter(x => x.id === id)[0];
            const index = newObjects.indexOf(itemToRemove);
            newObjects.splice(index, 1);
        } else newObjects.pop();
        this.setState({objects: newObjects, numberOfObjects: this.state.numberOfObjects - 1});
    }

    handleObjectClick(event) {
        this.removeObject(event.objectId);
    }

    handleClick(event) {
        this.addObject(event.clickPosition);
    }

    handleForceChange(event) {
        const forces = this.state.forces.map(f => {
            f.enabled = event.selection.includes(f.name);
            return f;
        });
        this.setState({forces: forces});
    }


    render() {
        const forceItems = this.state.forces.map(f => {
            return {id: f.name, text: f.name, checked: f.enabled};
        });
        const activeForces = this.state.forces.filter(f => f.enabled);
        return (
            <div>
                Molekyler: {this.state.numberOfObjects}
                <MechanicsView objects={this.state.objects} forces={activeForces}
                               size={this.state.size} walls={this.state.box.walls} onClick={this.handleClick}
                               onObjectClick={this.handleObjectClick}/>
                <input type="button" value="+" onClick={this.handleAddClick}/>
                <input type="button" value="-" onClick={this.removeObject}/>
                <CheckboxList items={forceItems} onChange={this.handleForceChange}/>
            </div>
        );
    }

    handleAddClick() {
        this.addObject();
    }
}
